import { Component, Input } from '@angular/core';
import { WeekdaysArrayAlt } from '../../../core/constants/base-calendar-values';
import { CandidateAvailability } from '../../../../api';
import { BaseWeekDays, BaseWeekDaysAlt } from '../../../modules/inquiry/_enums/base-inquiry.enum';

@Component({
  selector: 'base-candidate-weekdays-availability',
  templateUrl: './base-candidate-weekdays-availability.component.html',
})
export class BaseCandidateWeekdaysAvailabilityComponent {
  @Input() candidateAvailability: CandidateAvailability | undefined;

  weekdaysArray = WeekdaysArrayAlt;

  trackByWeekday(_: number, item: [BaseWeekDays, BaseWeekDaysAlt]) {
    return item[1];
  }
}
